module.exports = __webpack_public_path__ + "c47679fa8f9834529b369ee6d6e7cb71.png";